import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import React, { FC } from 'react';

import './MyCoursesSkeleton.scss';

export const MyCoursesSkeleton: FC = () => {
  return (
    <Skeleton>
      <div className="flex flex-col gap-2 w-full myCoursesSkeleton">
        <SkeletonItem className="skeletonItem skeletonItemFirst" />
        <SkeletonItem className="skeletonItem" />
        <SkeletonItem className="skeletonItem" />
      </div>
    </Skeleton>
  );
};
